import 'Debug';
import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Dropzone from "dropzone";
import Routes from '../../routes';

export default class Uploader extends Component {

  _TEMPLATES = {
    audio: 'audio',
    image: 'image'
  };

  _element = null;

  _instance = null;

  constructor(App, namespace, element) {
    super(...arguments);

    this.element = element;
    this.overwriteLogger();
    this.configure();
    this.initialize();
  }

  configure() {
    Dropzone.autoDiscover = false;
    return super.configure();
  }

  initialize() {
    this.start();
    return super.initialize();
  }

  set element(value) {
    this._element = value;
  }

  get element() {
    return this._element;
  }

  set instance(value) {
    this._instance = value;
  }

  get instance() {
    return this._instance;
  }

  overwriteLogger() {
    this.logger = debug(`App.${this.namespace}.${this.constructor.name}[${this.element.data('fileType')}]`);
  }

  start() {

    this.button = this.element.find('.is-file-button');
    this.progressBar = this.button.children('.progress');
    this.files = this.element.parent().find('.storage .storage-files');
    this.fileType  = this.element.data('fileType');
    this.fileHandler = this.element.data('fileHandler') || null;
    this.inputName = this.element.data('inputName') || null;

    let previewNode = document.querySelector('#storage-file-template-'+ (this._TEMPLATES[this.fileType] || this._TEMPLATES.image));

    this.instance = new Dropzone(
      this.element.get(0),
      {
        autoDiscover:      false,
        url:               Routes.API.STORAGE.UPLOAD,
        params: {
          content_type: this.element.data('contentType'),
          file_type:    this.fileType,
          file_handler: this.fileHandler
        },
        headers: {
          'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
        },
        maxFiles:          this.element.data('maxFiles'),
        maxFilesize:       this.element.data('maxFilesize'),
        acceptedFiles:     this.element.data('accepted'),
        uploadMultiple:    false,
        parallelUploads:   1,
        previewTemplate:   previewNode.innerHTML,
        previewsContainer: this.files.get(0),
        clickable:         this.button.get(0),
        // addRemoveLinks: true,
        createImageThumbnails: true,
        thumbnailWidth:    400,
        thumbnailHeight:   400,
        resize:            this.onResize,
        start: () => {
          return this.onStart(...arguments);
        },
        /**
         * The text used before any files are dropped.
         */
        dictDefaultMessage: this.App.Language.get('storage.default_message'),
        /**
         * The text that replaces the default message text it the browser is not supported.
         */
        dictFallbackMessage: this.App.Language.get('storage.fallback_message'),
        /**
         * If the filesize is too big.
         * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
         */
        dictFileTooBig: this.App.Language.get('storage.file_too_big'),
        /**
         * If the file doesn't match the file type.
         */
        dictInvalidFileType: this.App.Language.get('storage.invalid_file_type'),
        /**
         * If the server response was invalid.
         * `{{statusCode}}` will be replaced with the servers status code.
         */
        dictResponseError: this.App.Language.get('storage.response_error'),
        /**
         * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
         */
        dictCancelUpload: this.App.Language.get('storage.cancel_upload'),
        /**
         * The text that is displayed if an upload was manually canceled
         */
        dictUploadCanceled: this.App.Language.get('storage.upload_canceled'),
        /**
         * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
         */
        dictCancelUploadConfirmation: this.App.Language.get('storage.cancel_upload_confirmation'),
        /**
         * If `addRemoveLinks` is true, the text to be used to remove a file.
         */
        dictRemoveFile: this.App.Language.get('storage.remove_file'),
        /**
         * If this is not null, then the user will be prompted before removing a file.
         */
        dictRemoveFileConfirmation: null, // this.App.Language.get('storage.remove_file_confirmation'), Default: null
        /**
         * Displayed if `maxFiles` is st and exceeded.
         * The string `{{maxFiles}}` will be replaced by the configuration value.
         */
        dictMaxFilesExceeded: this.App.Language.get('storage.max_files_exceeded'),
        /**
         * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
         * `b` for bytes.
         */
        dictFileSizeUnits: {tb: 'TB', gb: 'GB', mb: 'MB', kb: 'KB', b: 'b'}
      }
    );

    this.instance.on('maxfilesexceeded', (file) => {

      return this.onMaxFilesExceeded(file);

    }).on('error', (file, response) => {

      return this.onError(file, response);

    }).on('totaluploadprogress', (progress) => {

      return this.onTotalUploadProgress(progress);

    }).on('addedfile', (file) => {

      return this.onAddedFile(file);

    }).on('removedfile', (file) => {

      return this.onRemovedFile(file);

    }).on('thumbnail', (file) => {

      return this.onThumbnail(...arguments);

    }).on('complete', () => {

      return this.onComplete();

    }).on('success', (file, response) => {
      return this.onSuccess(file, response);
    });

    this.instance.options.start();

  }

  onStart() {

    if (typeof window.files[ this.fileType ] !== 'undefined') {

      let handler = this.instance,
          counter = 0;

      window.files[ this.fileType ].forEach(function(file){

        let profile = {
          name:      file.id +'.'+ file.extension,
          extension: file.extension,
          size:      file.filesize,
          dataURL:   file.url,
          accepted:  true // Important to have correct number of uploaded files
        };

        handler.emit('addedfile', profile);

        /**
         handler.createThumbnailFromUrl(profile, handler.options.thumbnailWidth, handler.options.thumbnailHeight, handler.options.thumbnailMethod, true, function (dataUrl) {
                  handler.emit('thumbnail', profile, dataUrl);
                });
         */

        // handler.emit('thumbnail', file, file.original_url);
        handler.emit('complete', profile);
        handler.emit('success',  profile, {file: file});
        handler.files.push(profile);
        counter++;
        // handler.options.maxFiles = handler.options.maxFiles - counter;

      });

      this.App.Events.publish('tooltip.refresh', true);

    }

    this.logger(`Uploader[${this.fileType}] is ready`);

    this.logger(`Uploader[${this.fileType}] all files:`, this.instance.files);
    this.logger(`Uploader[${this.fileType}] accepted files:`, this.instance.getAcceptedFiles());

  }

  onResize(file) {

    let thumbNHeight = this.options.thumbnailHeight;
    let thumbNWidth = this.options.thumbnailWidth;

    let ratio = 1;
    if (file.width > file.height) {
      ratio = (file.width / file.height);
      thumbNHeight = thumbNHeight / ratio;
    } else if (file.height > file.width) {
      ratio = (file.height / file.width);
      thumbNWidth = thumbNWidth / ratio;
    }

    return {
      srcX: 0,
      srcY: 0,
      trgX: 0,
      trgY: 0,
      srcWidth: file.width,
      srcHeight: file.height,
      trgWidth: thumbNWidth,
      trgHeight: thumbNHeight
    };
  };

  onError(file, response) {

    let message = (typeof response === 'string' ? response : response.message),
      preview = $(file.previewElement);

    preview.find('.storage-file-error').removeClass('is-invisible').find('span').text(message);
    preview.find('input[type="hidden"]').remove();

    setTimeout(function(){
      preview.remove();
    }, 10000);

  }

  onAddedFile() {
    this.button.addClass('is-loading');
  }

  onRemovedFile(file) {
    this.logger('File removed:', file);
  }

  onThumbnail(file) {
    this.logger('Thumbnail created', arguments);
  }

  onComplete() {
    this.button.removeClass('is-loading');
    setTimeout(() => {
      this.progressBar.css('width', 0);
    }, 500);
  }

  onSuccess(file, response) {

    this.logger('Adding file..', response.file || {}, file);

    let preview = $(file.previewElement),
        previewContainer = preview.find('.storage-file-preview'),
        previewThumb = preview.find('.storage-file-thumb'),
        previewInfo = preview.find('.storage-file-info'),
        previewDetails = preview.find('.storage-file-details');

    preview
      .find('input[type="hidden"]')
      .attr('name', this.inputName)
      .val(response.file.id);

    previewDetails.html(response.file.details);

    if (response.file.extension === 'mp3') {

      previewContainer.removeClass('is-hidden');
      previewInfo.addClass('is-hidden');

      preview.find('audio')
        .data('file', file)
        .data('on-delete', (() => { this.instance.removeFile(file) }))
        .append('<source src="'+ response.file.url +'" type="audio/mp3" />');

      this.App.Events.publish('player.audio.scan', true);

    } else if (response.file.extension === 'svg' && typeof response.file.thumb === 'string') {

      previewThumb.html(response.file.thumb);
      this.drawSVGPaths(previewThumb.find('svg'), 1000, 3500, 50);

    } else if (['gif', 'jpeg', 'jpg', 'png', 'webp', 'svg'].indexOf(response.file.extension) === -1) {
      previewThumb.html('<img src="/assets/icons/file-types/'+ response.file.extension +'.svg" />');
    } else {
      previewThumb.html('<img src="' + response.file.url + '" />');
    }

    preview.find('.is-file-download-button').attr('href', response.file.url +'?download');

  }

  onMaxFilesExceeded(file) {

    this.instance.removeFile(file);

    if (this.element.data('maxFiles') === 1) {

      return this.App.UI.Dialog.confirm(this.App.Language.get('storage.overwrite_when_max_files_exceeded'), () => {
        this.instance.removeAllFiles();
        this.instance.addFile(file);
      });

    } else {
      return this.App.UI.Dialog.alert(this.App.Language.get('storage.remove_when_max_files_exceeded'));
    }

  }

  onTotalUploadProgress(progress) {
    this.progressBar.css('width', progress +'%');
  }

  drawSVGPaths(parentElement, timeMin, timeMax, timeDelay) {

    let paths = $(parentElement).find('path');

    //for each PATH..
    $.each(paths, function(i) {

      //get the total length
      let totalLength = this.getTotalLength();

      //set PATHs to invisible
      $(this).css({
        'stroke-dashoffset': -totalLength,
        'stroke-dasharray':  totalLength + ' ' + totalLength
      });

      //animate
      $(this).delay(timeDelay*i).animate({
        'stroke-dashoffset': 0
      }, {
        duration: Math.floor(Math.random() * timeMax) + timeMin,
        easing:   'easeInOutQuad'
      });
    });

  }

}